
const URL_SSO         = 'https://dev-api.deliryum.ai';
// const URL_MINSUR_API = 'https://dev-api.deliryum.ai';
const URL_MINSUR_API = 'https://dev-api.deliryum.ai';
// const URL_MINSUR_API = 'http://localhost:3000';

export const environment = {
    production: false,
    useMockData: false,
    // Base URLs exposed so services can rely on a single source of truth
    apiBaseUrl: URL_MINSUR_API,
    ssoBaseUrl: URL_SSO,
    endPoints: {
        // SSO
        'ssoLogin':               URL_SSO + '/auth/login',
        'ssoRegister':            URL_SSO + '/auth/register',
        'getUsers':               URL_SSO + '/user/',
        'getUserByUUID':          URL_SSO + '/user/uuid/',
        'notificationSettings':   URL_SSO + '/user/notification/settings',
        'getAllRoles':            URL_SSO + '/roles/',
        'updateUserPassword':     URL_SSO + '/user/password/change',

        // Minsur API
        'getLastIngress':         URL_MINSUR_API + '/detections/last-ingress',
        'getAvgByStep':           URL_MINSUR_API + '/detections/avg-by-step',
        'getLastDetections':      URL_MINSUR_API + '/detections/last-detections',
        'getDetectionByUUID':     URL_MINSUR_API + '/detections/timeline/',
        'getTablePaginated':      URL_MINSUR_API + '/detections/table',
        'getTableAlertPaginated': URL_MINSUR_API + '/detections/alerts-paginated',
        'updateDetectionByUUID':  URL_MINSUR_API + '/detections/manual-uuid',
        'getModifiedAlertsPaginated': URL_MINSUR_API + '/detections/modified-alerts-paginated',
        'getEsePercent':          URL_MINSUR_API + '/detections/ese-percent',
        'getAllPercent':          URL_MINSUR_API + '/detections/all-percent',
        'updateManualAllowByUUID': URL_MINSUR_API + '/detections/manual-allow-uuid',
        'getSummary'             : URL_MINSUR_API + '/detection/summary',

        // Reports
        'getReports':             URL_MINSUR_API + '/reports',
        'generateReport':         URL_MINSUR_API + '/reports/create',

        // Trucks module
        'getTrucks':              URL_MINSUR_API + '/detections/table',
        'getTruckDetail':         URL_MINSUR_API + '/detections/timeline/',
        'saveTruckValidation':    URL_MINSUR_API + '/detections/validate',
        // Charts
        'getChartsByDetectionUUID': URL_MINSUR_API + '/chart/by-detection', // + /:uuid
        'getChartTrend':            URL_MINSUR_API + '/chart/trend',

        // Alerts v2 (tabla con typeCod)
        'getAlertsTableWithType':   URL_MINSUR_API + '/alert/table', // la armas con path params

        'getDashboardMetrics':      URL_MINSUR_API + '/metrics/dashboard',
        'getDeteccionByUUID':       URL_MINSUR_API + '/detection/find/', // + uuid

        'updateAlert':              URL_MINSUR_API + '/alert/update', // PUT con body { uuid, status }

        

        

        
    }
};
